import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Gun from "../../Gun";
import Player from "../../Player";

export default class HeavyCannon extends Gun {
    constructor(player: Player) {
        super(player, {
            damage: 75,
            fireRate: 1.5,
            magSize: 12,
            reloadTime: 4,
            bulletSpeed: 150,
            mouseTrigger: 0
        })
    }

    onShoot(): void {
        const centerSpawnPos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const vel = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));

        this.player.engine.createBulletForAll(centerSpawnPos, vel, [
            {
                key: "team",
                value: this.player.team || "",
                type: PacketValueSerialType.String
            },
            {
                key: "damage",
                value: this.damage,
                type: PacketValueSerialType.UInt
            },
            {
                key: "ownerName",
                value: this.player.name,
                type: PacketValueSerialType.String
            },
            {
                key: "isExplosive",
                value: true,
                type: PacketValueSerialType.Bool
            },
            {
                key: "explosiveDamage",
                value: this.damage,
                type: PacketValueSerialType.Float
            },
            {
                key: "splashRadius",
                value: 32,
                type: PacketValueSerialType.Byte
            }
        ]);
    }
}